import React from "react";
import ReactGA from "react-ga4";

import { CategoryNameHr, ModuleNameHr, PageRoute, QueryParam } from "../../../models";
import { scrollToTop, stringifyURI } from "../../../services";

import styles from "./carStatistics.scss";
import { Link } from "react-router-dom";


export const CarStatisticsItem = ({ model, brand }) => {
  const handleClick = () => {
    ReactGA.event({
      category: "Popularne marke i modeli - model kliknut",
      action: "Click",
      label: `${brand} > ${model.name}`,
    });

    scrollToTop();


  }

  return (
    <Link
      key={model.name}
      to={model.customLink ||
        `/${ModuleNameHr.vehicles}/${CategoryNameHr.car}${PageRoute.search}${stringifyURI({
          category: CategoryNameHr.car,
          includeModelIds: model.includeModelIds,
          module: ModuleNameHr.vehicles
        }, QueryParam.searchQuery)}`}
      onClick={handleClick}
    >

      <li>
        <span className={styles.modelName}>{model.name}</span>
      </li>
    </Link>

  );
};



// WEBPACK FOOTER //
// ./src/containers/ModulePage/CarStatistics/CarStatisticsItem.tsx